import React from 'react';
import { token } from '@atlaskit/tokens';
import type { Direction } from './directionKeys.tsx';

export type MoveArrowProps = {
	x: number;
	y: number;
	direction: Direction;
};

const ROTATIONS: Record<Direction, number> = {
	up: 0,
	right: 90,
	down: 180,
	left: 270,
};

export const ARROW_RADIUS = 8;

const MoveArrow = ({ x, y, direction }: MoveArrowProps): React.JSX.Element => (
	<svg x={x - ARROW_RADIUS} y={y - ARROW_RADIUS}>
		<circle
			cx={ARROW_RADIUS}
			cy={ARROW_RADIUS}
			r={ARROW_RADIUS}
			fill={token('elevation.surface')}
		/>
		<path
			d="M5.61317 8.79009C5.22098 9.09525 4.65374 9.06771 4.29313 8.70735C3.90248 8.31696 3.90226 7.68379 4.29265 7.29313L7.29061 4.29313L7.38478 4.20991C7.40593 4.19346 7.42759 4.17797 7.45041 4.16443C7.45646 4.16044 7.46257 4.15651 7.46788 4.15179C7.49043 4.13766 7.51343 4.12453 7.5368 4.11352C7.54775 4.10778 7.55883 4.10224 7.57017 4.09582C7.59257 4.08522 7.61528 4.0755 7.6381 4.06749C7.65076 4.06258 7.66354 4.05791 7.67639 4.05288C7.69947 4.04506 7.72278 4.03811 7.74628 4.03247C7.76084 4.02866 7.77552 4.02518 7.7901 4.02172C7.81167 4.01716 7.83337 4.01331 7.85506 4.01043C7.87192 4.00798 7.8889 4.00595 7.90635 4.00418C7.93138 4.00189 7.95648 4.00054 7.98082 4.00018L8 4C8.05202 4 8.10311 4.00397 8.15227 4.01191C8.16598 4.01404 8.17966 4.01645 8.19387 4.01878C8.2213 4.02417 8.24832 4.03068 8.27458 4.03883C8.2833 4.04133 8.29199 4.04395 8.30085 4.04605C8.3292 4.05498 8.35701 4.06514 8.38384 4.07717C8.39319 4.08108 8.4025 4.08513 8.41222 4.08865C8.5338 4.14373 8.64241 4.22242 8.73218 4.31888L11.7069 7.29265L11.7901 7.38683C12.0952 7.77902 12.0677 8.34626 11.7073 8.70687L11.6132 8.79009C11.221 9.09525 10.6537 9.06771 10.2931 8.70735L9 7.415L9 12C9 12.5523 8.55228 13 8 13C7.48716 13 7.06449 12.614 7.00673 12.1166L7 12L7 7.413L5.70735 8.70687L5.61317 8.79009Z"
			fill={token('color.text.accent.gray.bolder')}
			transform={`rotate(${ROTATIONS[direction]}, ${ARROW_RADIUS}, ${ARROW_RADIUS})`}
		/>
	</svg>
);

export default MoveArrow;
